export default {
  setTokenInLocalStorage (token) {
    window.localStorage.setItem('mai-opti-token', token)
  },
  setUserInLocalStorage (user) {
    window.localStorage.setItem('mai-opti-user', JSON.stringify(user))
  },
  getTokenFromLocalStorage () {
    return window.localStorage.getItem('mai-opti-token')
  },
  getUserFromLocalStorage () {
    return JSON.parse(window.localStorage.getItem('mai-opti-user'))
  },
  removeTokenFromLocalStorage () {
    window.localStorage.removeItem('mai-opti-token')
  },
  removeUserFromLocalStorage () {
    window.localStorage.removeItem('mai-opti-user')
  },
  refreshAuth (commit, { user, token }) {
    commit('SET_TOKEN', token)
    commit('SET_USER', user)
  },
  /*
  * Simple 'debounce' implementation
  */
  currentTokenValid (duration, lastCall) {
    if (!duration || !lastCall) {
      return false
    }
    return (new Date().getTime() - lastCall) <= duration
  }
}



// WEBPACK FOOTER //
// ./src/modules/authentication/store/helpers.js